var _title, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUniverseIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "49px",
    viewBox: "0 0 49 49",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Universe")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 49,
    height: 49,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.Universes---Workflow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universe-Builder---New-Workflow---07",
    transform: "translate(-156.000000, -153.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(110.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universes-Symbol",
    transform: "translate(46.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8777778,31.4698276 C16.8777778,36.3388749 19.4184931,38.7733621 24.5,38.7733621 C29.5815069,38.7733621 32.1222222,36.3388749 32.1222222,31.4698276 L32.1222222,5.88 L38.22,5.88 L38.22,31.36 C38.22,35.7897348 37.0676041,39.020464 34.7627778,41.0522845 C32.4579514,43.084105 29.0279857,44.1 24.4727778,44.1 C19.9175698,44.1 16.4966781,43.084105 14.21,41.0522845 C11.9233219,39.020464 10.78,35.7897348 10.78,31.36 L10.78,5.88 L16.8777778,5.88 L16.8777778,31.4698276 Z",
    id: "U",
    fill: "#0039CB",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUniverseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Universe_icon.83620583.svg";
export { ForwardRef as ReactComponent };